export function getPathPrefix(): string {
  const basePath = __BASE_PATH__.split("/").filter(Boolean).join("/");
  return basePath ? `/${basePath}` : "";
}

export function buildCallbackUrl(next?: string): string {
  const prefix = getPathPrefix();
  const base = `${window.location.origin}${prefix}/auth/callback`;
  if (!next) return base;
  return `${base}?next=${encodeURIComponent(next)}`;
}

export function validateOrdinaryPostAuthNext(next: string | null | undefined): string {
  if (!next) return "/";
  if (!next.startsWith("/") || next.startsWith("//")) return "/";
  const lower = next.toLowerCase();
  if (lower === "/auth" || lower.startsWith("/auth/")) return "/";
  return next;
}